<template>
  <q-page class="flex-center">
    <div class="q-pa-md">
      <q-table
        title="Doadores"
        :data="emailTemplates.data"
        :columns="columns"
        row-key="id"
        :loading="$apollo.loading"
        :pagination.sync="pagination"
      >
        <template v-slot:top="props">
          <div class="row col-11 q-col-gutter-xs">
            <div class="col-12 text-center text-h3">Modelos de email</div>
          </div>
          <div class="col-1 text-center">
            <q-btn color="bg-purple-10" outline icon="add" @click="$router.push({name:'email-templates-new'})"></q-btn>
          </div>
        </template>
        <template v-slot:body-cell-options="value">
          <q-td>
            <q-btn v-if="value.row.type != 'fixo'" round color="primary" icon="edit"  @click="manda(value)"/>
          </q-td>
        </template>
      </q-table>
    </div>

  </q-page>
</template>

<script>
import { EMAIL_TEMPLATES } from '@/graphql/graphql'

export default {
  name: 'EmailTemplates',
  data () {
    return {
      emailTemplates: {
        data: [],
        paginatorInfo: {
          total: 0
        }
      },
      pagination: {
        sortBy: 'name',
        descending: false,
        page: 1,
        rowsPerPage: 50,
        rowsNumber: 50
      },
      columns: [
        {
          name: 'id',

          label: 'ID',
          align: 'left',
          field: 'id'

        }, {
          name: 'name',

          label: 'Nome do template',
          align: 'left',
          field: 'name'
        }, {
          name: 'type',

          label: 'Tipo do template',
          align: 'left',
          field: 'type'
        }, {
          name: 'subject',

          label: 'Assunto',
          align: 'left',
          field: 'subject'
        }, {
          name: 'options',

          label: 'Opções',
          align: 'left',
          field: 'options'
        }
      ]
    }
  },
  methods: {
    manda (value) {
      this.$router.push({ name: 'email-templates-edit', params: { id: value.row.id } })
    }
  },
  apollo: {
    emailTemplates: {
      query: EMAIL_TEMPLATES,
      variables () {
        return {
          page: this.pagination.page,
          count: this.pagination.rowsPerPage,
          orderBy: [{ field: 'name', order: 'ASC' }]
        }
      }
      // skip: true
      // pollInterval: 300, // ms
    }
  }
}
</script>
